import React from 'react';
import { startCase } from 'lodash';
import { PageTitle } from '@cordata/buffet';
import { useQueryParam } from '~/utils';
import Accordian from '~/components/common/Accordion';
import DisputeMatchingIndex from '~/pages/admin/identity-disputes/collection';
import { MatchStatus, MATCH_LIST_STATUSES } from '~/utils/const/identity';

const IdentityMatchLists = () => {
  const [expand, setExpand] = useQueryParam('expand');

  return (
    <>
      <PageTitle>Match Lists</PageTitle>

      <Accordian
        items={MATCH_LIST_STATUSES.map(matchStatusId => ({
          title: startCase(MatchStatus[matchStatusId]),
          body: <DisputeMatchingIndex matchStatusId={matchStatusId} />,
        }))}
        openPanel={expand}
        setOpenPanel={setExpand}
      />
    </>
  );
};

export default IdentityMatchLists;
